exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-header{\r\n  font-weight: bold;\r\n  text-align: left;\r\n  margin: 25px 0 0 26px;\r\n}\r\n\r\n.contact-details{\r\n  font-weight: bold;\r\n}\r\n\r\n.allContent{\r\n\r\n  margin:15px 30px 0 30px;\r\n  text-align: left;\r\n  height: 100vh\r\n}\r\n\r\n.exo-font {\r\n  font-family: 'Exo', sans-serif;\r\n  font-weight: 300;\r\n}\r\n\r\n", ""]);

// exports
